/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from 'react';
import { ARMcontext } from '../../../utils/context/context';
import { Teams } from '../../../utils/api';
import { FluidContainer, TablePlayersWellness, Loader } from '../../../components';
import { TableWrapper } from './styles';

export default ({
  isFirstLoad,
  playersGroup,
  playerNameSearch
}: {
  isFirstLoad: boolean;
  playersGroup: string;
  playerNameSearch: string
}) => {
  const [exams, useExams] = useState<Array<object | any>>([]);
  const [teamAverage, useTeamAverage] = useState({});
  const { HandleToastMessage } = useContext(ARMcontext);
  const { selectedTeam } = useContext(ARMcontext);
  const [loadingTable, setLoadingTable] = useState(true);
  const [isFirstLoadWellness, setFirstLoadWellness] = useState(true);
  const TEAMS = new Teams();

  useEffect(() => {
    if (!isFirstLoad || isFirstLoadWellness) getWellnessRecords();
  }, [playersGroup, selectedTeam]);

  useEffect(() => {
    setFirstLoadWellness(false)
  }, []);

  async function getWellnessRecords() {
    setLoadingTable(true)
    const examsResponse = await TEAMS.GetWellnessRecords(selectedTeam._id, playersGroup);
    if (examsResponse.status) {
      useExams(examsResponse.data.records);
      useTeamAverage(examsResponse.data.teamAverage);
    } else {
      HandleToastMessage(examsResponse?.data?.message || 'Server error', true, 2000, 'error');
    }
    setLoadingTable(false);
  }

  return (
    <>
      <FluidContainer>
        <TableWrapper>
          {loadingTable ? (
            <div style={{ width: "100%", display: 'block', alignItems: 'center' }}><Loader height="90px" /></div>
          ) : (
            <TablePlayersWellness filter={playerNameSearch} dataTableContent={exams} teamAverage={teamAverage} minWidth="1200px" />
          )}
        </TableWrapper>
      </FluidContainer>
    </>
  );
};
